import SelectoManager from "./SelectoManager";

class Selecto extends SelectoManager {

}
export default Selecto;
